<div class="widget-container mb-3">
	<sct-charts
		*ngIf="chartData.length; else noData"
		[type]="'BarChart'"
		[title]="title"
		[columnNames]="columnNames"
		[data]="chartData"
		[options]="config"
		(select)="onSelectRange($event)">
	</sct-charts>
	<ng-template #noData>
		<h1 class="h5 m-4">{{title}}</h1>
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</ng-template>
</div>

<app-modal [hasConfirmButton]="false" [hasCloseButton]="false" #popupModal [title]="title + ' (' + selectedRangeTitle + ')'" size="lg">
	<sct-custom-table
		*ngIf="tableData.length"
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</app-modal>
